import {NavList} from '@superweb/ui'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'

import type {Tariff} from '../../../../api'
import {Paper} from '../../../../components/ui'
import {useConfig} from '../../../../config'
import type {Path} from '../../../../types'
import {useLinkProps} from '../../../../utils'
import styleClasses from './classes.module.css'

type Props = {
  tariffs: Tariff[]
  path: Path
}

export function TariffsList({tariffs, path}: Props) {
  const i18n = useI18n()
  const {getLinkProps} = useLinkProps()
  const {getPath} = useConfig()

  return (
    <Paper className={styleClasses.list}>
      <Typography className={styleClasses.title} density="tight" level="title4" weight="medium">
        {i18n('tariffs-v3.tariffs-list.title', 'Выберите тариф')}
      </Typography>

      <div className={styleClasses.scrollable}>
        <NavList
          items={tariffs.map(tariff => {
            return {
              label: tariff.title,
              link: getLinkProps({
                href: getPath({...path, tariff: tariff.id}),
                isCurrent: () => path.tariff === tariff.id,
              }),
            }
          })}
        />
      </div>
    </Paper>
  )
}
